import { useSelector } from "react-redux";

const AllDataUser = () => {
  const user = useSelector((state) => state.verifyOtp.data);
  const lang = useSelector((state) => state.changeLang.lang);

  return { lang, user };
};

export default AllDataUser;
